
$(document).ready(function() {

  // MENU MOBILE
  $('.menu__nav').click(function () {
    $('header').toggleClass('opened');
    $('nav').toggleClass('opened');
    $('body').toggleClass('overflow');
    $('html').toggleClass('overflow');
    $('.brand__xs').toggle();
  });

  $('.has__sub-menu a').click(function () {     
    $(this).next().toggle();
    $(this).toggleClass('active');
  });

  // SLIDESHOW CLIENTS LOGOS
  $('.slider__clients-logos').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  // SLIDESHOW CLIENTS TESTIMONIALS
  $('.slider__clients-testimonials').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
  });

  // FIXED HEADER
  if ( $(window).width() > 768 ) {
    $(window).scroll(function(){
      if ($(this).scrollTop() > 0) {
         $('#header').addClass('fixed');
         $('.sub-menu').css('display','none');
      } else {
         $('#header').removeClass('fixed');
      }
    });
  }

});